import './css/timeline.css'

import timelineData from './data.js';

const TimelineItem = ({data}) => (
    <div className='timeline-item'>
        <span className='circle'>
        <time className='time-text'>{data.date}</time>
        </span>
        <div className='timeline-item-content'>
            <span className='tag timeline-item-content-tag' z-index='900'>
                <img className='img1' src={data.category.img} alt={data.alttext}/>
                <br/>
                {data.category.hasimg2 && (<img className='img2' src={data.category.img2} alt={data.alttext}/>)}
            </span>
            <p z-index='1000'>{data.text}</p>  
            {data.link && (
            <a 
                href={data.link.url} 
                
                target='_blank'
                rel='noopener noreferrer'
            >
                {data.link.text}
            </a>
        )}
        </div>
    </div>
);


const Timeline = () =>

    (
        <div className='timeline-container'>    
            {timelineData.map((data,idx) =>(
                <TimelineItem data={data} key={idx} />
            ))}
        </div>
    );

export default Timeline;